
import Vue from 'vue'
import util from '@/libs/util'
import common from '@/libs/common.mixin'
import wxjssdk from '@/libs/wxjssdk.mixin'

import Upload from 'c%/upload'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import PlayVideo from 'c%/PlayVideo.vue'

export default{
mixins: [ common,wxjssdk ],
components:{
Upload,
Flexbox,
FlexboxItem,
PlayVideo
},
data () {
return {
info: {},
popup_add: false
}
},
mounted () {
this.init_data()
},
methods: {
setShare () {
let info = this.info
let [title,img,desc,link] = [util.sprintf('%s-%s',info.student.student_name,info.title),'',info.content,'']

link = location.href

if(info.edu_growup_item.length > 0){
let obj = info.edu_growup_item.find(i=>i.edu_growup_pic.length>0)
if(obj){
img = obj.edu_growup_pic[0].url
}
}


this.setWxShare(title,img,desc,link)
},
init_data () {
let uri = util.sprintf('/api/share/edu_growup?eg_id=%s&with=edu_growup_item.edu_growup_pic,student,one_class',this.$route.params.id)
this.$rest(uri).get()
.success(data=>{
this.info = data
this.setShare()
}).error(response=>{
this.toast(response.body.messsage,'text')
})
},
UploadList (item,position,type) {
let [list,attachments,img_list] = [item.edu_growup_pic,[],[]]

if(list.length > 0){
let _this = this
let filter = function(item) {
let s = item.url.split('.'),t = s[s.length-1]
return item.position == position&&_this[type].indexOf(t) > -1
}
attachments = list.filter(filter)
if(attachments.length > 0){
attachments.forEach(a=>{
img_list.push(a.url)
})
}
}
return img_list
},
preview (current,list) {
this.previewImage(current,list)
},
previewVideo (file) {
this.$refs.playVideo
.set('video',file)
.show()
}
},
computed: {
abilities () {
let [lesson_config,ability] = [this.$store.state.user.info.global.lesson_config,[]]
if(lesson_config && lesson_config.ability){
ability = lesson_config.ability
}
return ability
},
image () {
return ['image','jpg','jpeg','png','gif','bmp','IMAGE','JPG','JPEG','PNG']
},
video () {
return ['video','rm','rmvb','mpeg1－4','mov','mtv','dat','wmv','avi','3gp','amv','dmv','flv','mp4','MP4','MOV']
}
}
}



// WEBPACK FOOTER //
// ./src/views/public/contrast-detail.vue